import React from 'react';
import * as dates from '@simplybenefits/sb-dates';
import Table from '@mui/material/Table/Table';
import TableHead from '@mui/material/TableHead/TableHead';
import TableRow from '@mui/material/TableRow/TableRow';
import TableCell from '@mui/material/TableCell/TableCell';
import TableBody from '@mui/material/TableBody/TableBody';
import PropTypes from 'prop-types';
import { helpers, constants } from '@simplybenefits/sb-utils';
import { Theme } from "@simplybenefits/sb-ui-library";

/**
 * @param column
 * @param item
 * @returns {*}
 * @private
 */
function _getValue(column, item) {
    if (column.type === "dollar") {
        return item[column.title] === null ? '$0.00' : `$${ helpers.numberWithCommasDecimals(parseFloat(item[column.title])) }`;
    }

    if (column.type === 'birthdate' || column.type === 'date') {
        return item[column.title] ?
            column.title === 'Paid Date' || column.title === 'Date Paid' ?
                dates.getLocalDisplay(item[column.title], 'll')
                :
                dates.getStartOfDay(item[column.title], 'll')
            :
            '-';
    }

    if (column.type === 'memberStatus') {
        return constants.memberStatusMap[item[column.title]];
    }

    return item[column.title] || 'N/A';
}

/**
 * @param report
 * @param classes
 * @returns {*}
 * @constructor
 */
const ReportTable = ({ report }) => {
    const styles = {
        table: {
            display: 'block',
            overflowX: 'auto',
            paddingBottom: '20px',
            width: '100%'
        },
        scrollbar: {
            '&::webkitScrollbar': {
                height: '15px',
                width: '15px'
            },
            '&::webkitSrollbarThumb': {
                backgroundColor: Theme.colors.surface,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, .5)'
            },
            '&::webkitScrollbarTrack': {
                backgroundColor: Theme.colors.backgroundGrey,
                borderRadius: '10px',
                boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.2)'
            }
        },
        tableHeading: {
            paddingTop: "4px",
            paddingBottom: "4px",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            fontFamily: Theme.fonts.type.medium,
            color: Theme.colors.surface,
            whiteSpace: "nowrap",
            borderBottom: "none"
        },
        tableCell: {
            paddingTop: "4px",
            paddingBottom: "4px",
            fontFamily: Theme.fonts.type.base,
            whiteSpace: "nowrap",
            paddingRight: "2vw",
            paddingLeft: "2vw",
            color: Theme.colors.mainTextGrey
        }
    };
    return (
        <div style={{ overflow: "auto", maxHeight: 600, ...styles.scrollbar }}>
            <Table padding="normal">
                <TableHead>
                    <TableRow sx={{ backgroundColor: Theme.colors.skyBlue }}>
                        {
                            report.columns.map((column) => (
                                <TableCell key={column.title} style={styles.tableHeading}>
                                    { column.title }
                                </TableCell>
                            ))
                        }
                    </TableRow>
                </TableHead>

                <TableBody>
                    {
                        report.items.map((item, index) => {
                            let backgroundObject = { border: "none" };
                            if (index % 2 !== 0) {
                                backgroundObject = { backgroundColor: Theme.colors.backgroundGrey, border: "none" };
                            }

                            return (
                                <TableRow key={`${ item.cert }+${ index }`}>
                                    {
                                        // eslint-disable-next-line no-shadow
                                        report.columns.map((column, index) => (
                                            <TableCell key={index} sx={{ ...styles.tableCell, ...backgroundObject }}>
                                                { _getValue(column, item) }
                                            </TableCell>
                                        ))
                                    }
                                </TableRow>
                            );
                        })
                    }
                </TableBody>
            </Table>
        </div>
    );
};

ReportTable.propTypes = {
    report: PropTypes.object || PropTypes.array
};

export default (ReportTable);